module.exports = __webpack_public_path__ + "static/media/btbms_desktop_hero_en.b670acd8.jpg";